let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("14NIX")).then(() => parcelRequire('argEv'));